import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { UserDTO } from '@employer-on-record/shared';
import { queryClient } from '@/lib/queryClient';

interface AuthState {
	user: UserDTO | null;
	token: string | null;
	isAuthenticated: boolean;
	login: (user: UserDTO, token: string) => void;
	logout: () => void;
}

export const useAuthStore = create<AuthState>()(
	persist(
		(set) => ({
			user: null,
			token: null,
			isAuthenticated: false,
			login: (user, token) => {
				queryClient.clear();
				set({ user, token, isAuthenticated: true });
			},
			logout: () => {
				set({ user: null, token: null, isAuthenticated: false });
				queryClient.clear();
			}
		}),
		{ name: 'eor-admin-auth' }
	)
);
